import './WorkLogContent.css'

interface WorkLogContentProps {
  html: string
  className?: string
}

/**
 * Work Log 설명 HTML 렌더링 컴포넌트.
 *
 * 저장된 description은 Tiptap 기반 에디터로부터 HTML 문자열로 들어온다(예: <p>, <strong>, <ul>).
 * 레거시 데이터로 일반 평문이 들어오는 경우도 white-space: pre-wrap 으로 줄바꿈을 보존한다.
 *
 * 보안: 작성자는 인증된 ADMIN/ENGINEER 로 제한되므로 프로젝트의 기존 <code>dangerouslySetInnerHTML</code>
 * 패턴(SupportHistory, FeedbackHistory)과 동일한 신뢰 모델을 따른다. 추가 허용 계정이 생기면 DOMPurify
 * 도입을 고려할 것.
 */
export function WorkLogContent({ html, className }: WorkLogContentProps) {
  return (
    <div
      className={`worklog-content${className ? ' ' + className : ''}`}
      dangerouslySetInnerHTML={{ __html: html || '' }}
    />
  )
}
